// LIBRARIES //
import React from 'react';
import { browserHistory } from 'react-router';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Divider, AntdButton, colors } from '@yuhuinc/ui-library';

// COMPONENTS //
import CardHeader from '../CardComponent/CardHeader';
import CardBody from '../CardComponent/CardBody';

// HELPERS //
import { getTranslatedString } from 'helpers/i18n';
import { primaryButtonColors, buttonColors } from '../ButtonColors';

// ACTIONS //
import { getTenant } from 'actions/landlordTenantsActions';
import { closeResidentDrawer, openResidentDrawer } from '../store/actions';

const SpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0;
`;

const Header = styled.span`
  font-size: 18px;
  line-height: 24px;
  font-weight: 600;
  color: ${colors.colors.gray[9]};
`;

const SubHeader = styled.span`
  font-weight: 400;
  font-size: 18px;
`;

const StyledDivider = styled(Divider)`
  margin-top: 8px;
  margin-bottom: 16px;
`;

const StyledButton = styled(AntdButton)`
  margin-top: 31px;
  margin-bottom: 32px;
`;

const StyledText = styled.p`
  line-height: 20px;
  font-size: 16px;
  ${props => (props.right ? 'text-align: right;' : '')};
`;

const listLeaseHolders = (leaseHolders, getTenant, closeResidentDrawer, openResidentDrawer) => {
  const buttonOnClick = async leaseHolder => {
    closeResidentDrawer();
    browserHistory.push(`/companies/tenants?tenantId=${leaseHolder.id}`);
    await getTenant(leaseHolder.id, { all_maintenance_tickets: true });
    openResidentDrawer();
  };
  const mappedLeaseHolders = leaseHolders.map(leaseHolder => (
    <AntdButton
      type="link"
      style={{ ...buttonColors, paddingLeft: 0 }}
      label={leaseHolder.full_name}
      onClick={async () => await buttonOnClick(leaseHolder)}
    />
  ));

  return mappedLeaseHolders;
};

const LeaseDetails = ({
  leaseData,
  otherLeaseHolders,
  getTenant,
  closeResidentDrawer,
  openResidentDrawer,
}) => {
  return (
    <div>
      <CardHeader>
        {getTranslatedString('residentDrawer.residentDetailTab.leaseDetails.title')}
      </CardHeader>
      <CardBody>
        <SpaceBetween>
          <Header>{`${leaseData.property_name} ${getTranslatedString(
            'residentDrawer.residentDetailTab.leaseDetails.building'
          )}`}</Header>
          <SubHeader>{`${getTranslatedString(
            'residentDrawer.residentDetailTab.leaseDetails.unit'
          )} ${leaseData.unit_number}`}</SubHeader>
        </SpaceBetween>
        <StyledDivider />
        <SpaceBetween>
          <div>
            <SubHeader>
              {getTranslatedString('residentDrawer.residentDetailTab.leaseDetails.leaseStartDate')}
            </SubHeader>
            <StyledText>{leaseData.lease_start_date}</StyledText>
          </div>
          <div>
            <SubHeader>
              {getTranslatedString('residentDrawer.residentDetailTab.leaseDetails.leaseEndDate')}
            </SubHeader>
            <StyledText right>{leaseData.lease_end_date}</StyledText>
          </div>
        </SpaceBetween>
        <StyledButton
          label={getTranslatedString(
            'residentDrawer.residentDetailTab.leaseDetails.viewLeaseButton'
          )}
          type={'primary'}
          style={primaryButtonColors}
          onClick={() => browserHistory.push(`/companies/rent_roll/${leaseData.id}`)}
        />

        <SubHeader>
          {getTranslatedString('residentDrawer.residentDetailTab.leaseDetails.otherLeaseHolders')}
        </SubHeader>
        {listLeaseHolders(otherLeaseHolders, getTenant, closeResidentDrawer, openResidentDrawer)}
      </CardBody>
    </div>
  );
};

LeaseDetails.defaultProps = {
  leaseData: {},
};

export default connect(null, { getTenant, closeResidentDrawer, openResidentDrawer })(LeaseDetails);
